import { apiFetch } from './api';

export interface CsatSettings {
  enabled: boolean;
  prompt: string | null;
  askComment: boolean;
}

export interface CsatSummary {
  sent: number;
  answered: number;
  responseRate: number;
  average: number | null;
  satisfied: number | null;
  /** Counts for 1..5 stars, in that order. */
  distribution: [number, number, number, number, number];
}

export interface CsatResponse {
  sessionId: string;
  rating: number | null;
  comment: string | null;
  channel: string;
  answeredAt: string | null;
}

export interface CsatOverview {
  settings: CsatSettings;
  days: number;
  summary: CsatSummary;
  recent: CsatResponse[];
}

export interface ConversationSurvey {
  status: 'pending' | 'sent' | 'answered' | 'expired';
  rating: number | null;
  comment: string | null;
  delivery: 'widget' | 'channel' | 'email' | null;
  deliveryError: string | null;
  answeredAt: string | null;
}

export const getCsat = (siteId: string, days = 30) =>
  apiFetch<CsatOverview>(`/api/admin/sites/${siteId}/csat?days=${days}`);

export const saveCsatSettings = (siteId: string, s: CsatSettings) =>
  apiFetch<{ settings: CsatSettings }>(`/api/admin/sites/${siteId}/csat`, {
    method: 'PUT',
    body: JSON.stringify(s),
  }).then((r) => r.settings);

export const getConversationSurvey = (sessionId: string) =>
  apiFetch<{ survey: ConversationSurvey | null }>(`/api/csat/session/${sessionId}`).then((r) => r.survey);
